import { stack as d3_stack, stackOffsetDiverging as d3_stackOffsetDiverging } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'

export default function BarChartDataController(rows, config = {}, hiddenItems) {
  let headers = rows[0]
  let propperHeaders
  let dims
  if (config.mode === 'stacked') {
    propperHeaders = ['id', ...headers.slice(1)]
    dims = 2
  } else if (config.mode === 'grouped') {
    propperHeaders = ['id', ...headers.slice(1)]
    dims = 2
  } else {
    propperHeaders = ['id', 'value']
    dims = 1
  }
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)
  if(hiddenItems) data = data.filter((d)=>hiddenItems.indexOf(d.id)<0)
  //Sort data by mode
  if (config.dataSorting !== 'none') {
    if (config.mode === 'stacked') {
      data.sort((a, b) => {
        let aAddition = a.value.reduce((accumulator, current) => (accumulator += current.value), 0)
        let bAddition = b.value.reduce((accumulator, current) => (accumulator += current.value), 0)
        let diff = aAddition - bAddition
        return config.dataSorting === 'asc' ? diff : -diff
      })
    } else {
      data.sort((a, b) => {
        let diff = a.value - b.value
        return config.dataSorting === 'asc' ? diff : -diff
      })
    }
  }

  let extent
  if (config.mode === 'stacked') {
    extent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } else if (config.mode === 'grouped') {
    extent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } else {
    extent = d3_extent(data, d => d.value)
  }
  if (extent[0] > 0) extent[0] = 0
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  //BASTANTE BASURIL ESTO... pero lo que da parece que no esta mal...
  if (config.mode === 'stacked') {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    if(hiddenItems) keys = keys.filter((d)=>hiddenItems.indexOf(d)<0)
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let objArray = data.map(layer => {
      let res = { id: layer.id }
      layer.value.forEach(dd => {
        res[dd.id] = dd.value
      })
      return res
    })
    let stack = d3_stack()
      .value((d, key) => getSafeValue(d[key]))
      .keys(keys)
      .offset(d3_stackOffsetDiverging)

    let stacked = stack(objArray)
    let lastLayer = stacked[stacked.length-1]
    let firstLayer = stacked[0]
    
    let mins = firstLayer.reduce((mins,z,i)=>{
      stacked.forEach((layer)=>{
        if(layer[i][0]<mins[i]) mins[i] = layer[i][0]
      })
      return mins
    },new Array(firstLayer.length).fill(Infinity))

    let maxs = firstLayer.reduce((maxs,z,i)=>{
      stacked.forEach((layer)=>{
        if(layer[i][1]>maxs[i]) maxs[i] = layer[i][1]
      })
      return maxs
    },new Array(firstLayer.length).fill(-Infinity))
    
    let result = stacked.map(layer => {
      return {
        id: layer.key,
        index: layer.index,
        value: layer.map((dd,i) => {
          return {
            id: dd.data.id,
            value: dd.data[layer.key],
            safeValue: getSafeValue(dd.data[layer.key]),
            y0: dd[0],
            y1: dd[1],
            layerIndex: layer.index,
            isLastLayer: maxs[i] === dd[1], //keys.indexOf(layer.key) === keys.length - 1, // 
            isFirstLayer: mins[i] === dd[0], //keys.indexOf(layer.key) === 0, // 
            parentId: layer.key,
            // por arriba no hace falta...
            barMax: maxs[i], //lastLayer[i][1],
            // por abajo es guarro mirar el config y no poder mirar el "axis.y.scale.domain()"....
            // barMin: firstLayer[i][0],
            barMin: mins[i], //config.AxisHelper.y.domain[0]==='auto'?firstLayer[i][0]:-config.AxisHelper.y.domain[0] 
          }
        }),
      }
    })
    return result
  } else if (config.mode === 'grouped') {
    // return data.map((d,i)=>{
    //   if(!d.id) d.id = i
    //   return d
    // })
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)
    if(hiddenItems) keys = keys.filter((d)=>hiddenItems.indexOf(d)<0)
    
    let res = keys.map(key => {
      return {
        id: key,
        value: data.map(dd => {
          let cand = dd.value.find(ddd => ddd.id === key)
          return {
            id: cand.parentId,
            parentId: cand.id,
            value: cand.value,
            safeValue: getSafeValue(cand.value),
          }
        }),
      }
    })
    return res
  } else {
    return data.map((d, i) => {
      if (!d.id) d.id = i
      d.safeValue = getSafeValue(d.value)
      return d
    })
  }
}
